import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MyHttpClient } from '../http-client';
import * as i0 from "@angular/core";
import * as i1 from "../http-client";
var SubscriptionService = /** @class */ (function () {
    function SubscriptionService(http) {
        this.http = http;
        this.rulePath = "/api/subscription/rule";
        this.ruleByIdPath = "/api/subscription/rule";
        this.createrulePath = "/api/accessfee/rule";
        this.planByIdPath = "/api/accessfee/plan";
        this.fetchPlans = "/api/accessfee/fetchPlans";
    }
    SubscriptionService.prototype.getApplicableTypes = function (sdids, modeId) {
        return this.http
            .post(environment.server + "/api/subscription/applicable-types", { sdids: sdids || [], modeId: modeId })
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.getFeedbackContexts = function (cityId, modeId) {
        return this.http
            .get(environment.server + "/api/subscription/feedback-contexts", { cityId: cityId, modeId: modeId })
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.getSkipServiceHierarchyToggle = function () {
        return this.http
            .get(environment.server + "/api/subscription/skip-service-hierarchy")
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.createSubscriptionRules = function (req) {
        return this.http
            .post(environment.server + this.rulePath, req)
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.createBillingPlan = function (req) {
        return this.http
            .post(environment.server + this.createrulePath, req)
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.getSubscriptionRule = function (id) {
        return this.http
            .get(environment.server + this.ruleByIdPath + "/" + id)
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.getBillingPlan = function (id) {
        return this.http
            .get(environment.server + this.planByIdPath + "/" + id)
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.getBillingPlans = function (payload) {
        return this.http
            .post(environment.server + this.fetchPlans, payload)
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.updateBillingPlan = function (planId, payload) {
        return this.http
            .patch(environment.server + "/api/accessfee/plan/" + planId, payload)
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.getHighestPriorityHHRule = function (serviceDetails) {
        return this.http
            .post(environment.server + "/api/subscription/fetchRules", {
            filters: {
                serviceDetails: serviceDetails,
                isAutoAssignedToHH: true,
                active: true
            },
            pagination: {
                page: 1,
                pageSize: 1
            },
            queryParams: {
                sortBy: "priority",
                sortOrder: -1
            }
        })
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.getHighestPriorityDefaultRule = function (serviceDetails) {
        return this.http
            .post(environment.server + "/api/subscription/fetchRules", {
            filters: {
                serviceDetails: serviceDetails,
                isDefaultSubscription: true,
                active: true
            },
            pagination: {
                page: 1,
                pageSize: 1
            },
            queryParams: {
                sortBy: "priority",
                sortOrder: -1
            }
        })
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.getSamePriorityRules = function (serviceDetails, startTime, endTime, priorities) {
        return this.http
            .post(environment.server + "/api/subscription/fetchRules", {
            filters: {
                serviceDetails: serviceDetails,
                startTime: startTime,
                endTime: endTime,
                active: true,
                isAutoAssignedToHH: false,
                priorities: (priorities || []).map(function (p) { return Number(p); })
            },
            pagination: {
                page: 1,
                pageSize: environment.maxRulesCreationAtOnce
            }
        })
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.getRules = function (payload) {
        return this.http
            .post(environment.server + "/api/subscription/fetchRules", payload)
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.getConfigRequests = function (kind, pageNumber, pageLimit) {
        return this.http
            .get(environment.server + "/api/subscription-config-requests", {
            kind: kind,
            pageNumber: String(pageNumber),
            pageLimit: String(pageLimit)
        })
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.getConfigRequestById = function (requestId, kind) {
        return this.http
            .get(environment.server + "/api/subscription-config-requests/" + requestId, { kind: kind })
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.decideConfigRequest = function (requestId, action, kind) {
        return this.http
            .patch(environment.server + "/api/subscription-config-requests/" + requestId + "/" + action, { kind: kind })
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.updateRule = function (ruleId, payload) {
        return this.http
            .patch(environment.server + "/api/subscription/rule/" + ruleId, payload)
            .pipe(catchError(this.handleError));
    };
    SubscriptionService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        }
        else {
            console.error("Backend returned code " + error.status + ", body was:", error.error);
        }
        return throwError(error);
    };
    SubscriptionService.ngInjectableDef = i0.defineInjectable({ factory: function SubscriptionService_Factory() { return new SubscriptionService(i0.inject(i1.MyHttpClient)); }, token: SubscriptionService, providedIn: "root" });
    return SubscriptionService;
}());
export { SubscriptionService };
